import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const RadioButtonFormContainer = styled.div`
  width: 100%;
`;

export const RadioButtonFormLabel = styled.label`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  opacity: 0.9;
  text-transform: uppercase;
  display: block;
`;

export const RadioButtonFormContent = styled.div`
  display: flex;
  margin-top: 40px;
  cursor: pointer;
`;

export const RadioButtonFormGroup = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-left: 60px;
  }
`;

export const RadioButtonLabel = styled.label`
  margin-left: 8px;
  color: ${colors.textPrimary};
  font-size: 14px;
  line-height: 18px;
`;

export const RadioButtonInputShow = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  padding: 2px;
  background: ${colors.white};
  border: 1px solid ${prop => prop.selected ? colors.textHyperlink : colors.grayLight};
  position: relative;
  transition: ease-in-out .2s;

  &:after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 8px;
    border-radius: 7px;
    height: 8px;
    background: ${prop => prop.selected ? colors.textHyperlink : colors.white};
  }
`;

export const RadioButtonInput = styled.input`
  width: 0px;
  height: 0px;
  border: 0;
`;
